import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import App from './app/app';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import ReactQueryRewind from 'react-query-rewind';
const container = document.getElementById('root');

const queryClient = new QueryClient();

const root = createRoot(container as HTMLElement);
root.render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
      <ReactQueryRewind />
    </QueryClientProvider>
  </StrictMode>,
);
